import {type IAsset} from '../schema';
import {canCreateShareLinkFromAsset} from './canCreateShareLinkFromAsset';

export const canCreateEmbedLinkFromAsset = (asset?: IAsset): boolean =>
	canCreateShareLinkFromAsset(asset) &&
	asset.fileFormatFamily.includes('image');

export default canCreateEmbedLinkFromAsset;
